<template>
  <div
    class="
      rentpress-shortcode-single-floorplan-information-wrapper
      rentpress-inherited-font-family
    "
  >
    <v-banner
      v-if="floorplan.floorplan_specials_message"
      elevation="10"
      :color="primaryColor"
      dark
      class="rentpress-inherited-font-family text-h6 text-center px-5"
      style="z-index: 1"
    >
      <div
        @click="
          navigateToExternalSite(floorplan.floorplan_specials_link);
          gtag('event', 'special_view_rentpress', {
            property_name: floorplan.property_name,
            city: floorplan.property_city,
            floorplan_name: floorplan.floorplan_post_title
          });
        "
        style="height:100%;width100%;"
      >
        <span class="font-weight-black">
          <v-icon class="pb-2">mdi-star</v-icon>
          SPECIAL:
        </span>
        {{ floorplan.floorplan_specials_message }}
      </div>
    </v-banner>
    <v-row no-gutters justify="center" class="pa-3">
      <v-col xl="6" lg="6" md="12" sm="12" cols="auto">
        <v-carousel
          :show-arrows="carouselImages.length != 1"
          :hide-delimiters="carouselImages.length == 1"
          height="100%"
          class="rentpress-floorplan-carousel"
        >
          <v-carousel-item
            v-for="(carouselImage, imageIndex) in carouselImages"
            :key="imageIndex"
          >
            <v-img
              :src="carouselImage.src"
              :alt="
                carouselImage.alt ||
                  floorplan.floorplan_post_title + ' image ' + imageIndex
              "
              contain
              max-height="100%"
              @click="viewImageFullscreen(imageIndex)"
              class="rentpress-floorplan-carousel-image"
            >
              <template v-slot:placeholder>
                <div class="d-flex align-center justify-center fill-height">
                  <v-progress-circular
                    :color="
                      parentPropertyColor ? parentPropertyColor : 'primary'
                    "
                    indeterminate
                  ></v-progress-circular>
                </div>
              </template>
            </v-img>
          </v-carousel-item>
        </v-carousel>
        <div
          v-if="floorplan.floorplan_matterport_url || engrainMapLink"
          class="rentpress-floorplan-iframe-buttons rentpress-floorplan-under-image-buttons"
        >
          <a
            href="#rentpress-virtual-tour"
            class="floorplan-virtual-tour-button circle-button"
            :style="{ borderColor: primaryColor }"
            v-if="floorplan.floorplan_matterport_url"
          >
            <v-icon medium :color="primaryColor"
              >mdi-play-circle-outline</v-icon
            >
            <p :style="{ color: primaryColor }">Virtual Tour</p>
          </a>
          <a
            href="#single_floorplan_sightmap"
            class="floorplan-show-map-button circle-button"
            :style="{ borderColor: primaryColor }"
            v-if="engrainMapLink"
          >
            <v-icon medium :color="primaryColor">mdi-map-marker</v-icon>
            <p :style="{ color: primaryColor }">Show Map</p>
          </a>
        </div>
      </v-col>
      <v-overlay
        z-index="1000000"
        :value="galleryOverlay"
        opacity="0.85"
        v-touch="{
          left: () => gallerySwipe('Left'),
          right: () => gallerySwipe('Right'),
          up: () => gallerySwipe('Up'),
          down: () => gallerySwipe('Down')
        }"
      >
        <v-carousel
          :show-arrows="carouselImages.length != 1"
          :hide-delimiters="carouselImages.length == 1"
          v-model="selectedGalleryImage"
          height="100vh"
        >
          <v-carousel-item
            v-for="(galleryImage, galleryImageKey) in carouselImages"
            :key="galleryImageKey"
          >
            <v-sheet
              color="transparent"
              height="100vh"
              width="100vw"
              tile
              @click.self="galleryOverlay = false"
            >
              <v-row
                class="fill-height"
                align="center"
                justify="center"
                @click.self="galleryOverlay = false"
              >
                <v-lazy
                  :min-height="200"
                  :options="{ threshold: 0.5 }"
                  transition="fade-transition"
                >
                  <v-img
                    max-height="95vh"
                    :height="galleryImage.height"
                    max-width="95vw"
                    class="rentpress-floorplan-carousel-image-lightbox"
                    :src="galleryImage.src"
                    contain
                  />
                  <template v-slot:placeholder>
                    <div class="d-flex align-center justify-center fill-height">
                      <v-progress-circular
                        :color="
                          parentPropertyColor ? parentPropertyColor : 'primary'
                        "
                        indeterminate
                      ></v-progress-circular>
                    </div>
                  </template>
                </v-lazy>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
        <v-btn
          @click="galleryOverlay = false"
          fab
          top
          right
          large
          absolute
          rounded
          :color="parentPropertyColor"
          class="primary mt-12 rentpress-floorplan-gallery-close-button"
        >
          <v-icon x-large color="black">mdi-close</v-icon>
        </v-btn>
      </v-overlay>
      <v-col xl="6" lg="6" md="12" sm="12" cols="auto">
        <v-card tile flat class="pl-5">
          <div class="rentpress-floorplan-information-top-wrapper">
            <div class="rentpress-floorplan-information-title-price-wrapper">
              <v-card-title
                v-if="useFPName"
                class="rentpress-inherited-font-family text-h3 secondary--text pl-0 rentpress-single-floorplan-title"
              >
                {{ floorplan.floorplan_post_title }}
              </v-card-title>
              <v-card-text
                class="rentpress-inherited-font-family font-weight-bold text-h5 pl-0"
              >
                <span
                  v-if="
                    floorplan.floorplan_rent_type_selection ==
                      'Minimum - Maximum' &&
                      floorplan.floorplan_rent_min &&
                      floorplan.floorplan_rent_max &&
                      floorplan.floorplan_rent_min !=
                        floorplan.floorplan_rent_max
                  "
                >
                  {{ formatter.format(floorplan.floorplan_rent_min) }} -
                  {{ formatter.format(floorplan.floorplan_rent_max) }}
                </span>
                <span
                  v-else-if="
                    floorplan.floorplan_rent_type_selection_cost &&
                      floorplan.floorplan_rent_type_selection_cost > 100
                  "
                >
                  Starting at
                  {{
                    this.formatter.format(
                      floorplan.floorplan_rent_type_selection_cost
                    )
                  }}
                </span>
              </v-card-text>
            </div>
            <div
              v-if="floorplan.floorplan_matterport_url || engrainMapLink"
              class="rentpress-floorplan-iframe-buttons rentpress-floorplan-title-buttons"
            >
              <a
                href="#rentpress-virtual-tour"
                class="floorplan-virtual-tour-button circle-button"
                :style="{ borderColor: primaryColor }"
                v-if="floorplan.floorplan_matterport_url"
              >
                <v-icon medium :color="primaryColor"
                  >mdi-play-circle-outline</v-icon
                >
                <p :style="{ color: primaryColor }">Virtual Tour</p>
              </a>
              <a
                href="#single_floorplan_sightmap"
                class="floorplan-show-map-button circle-button"
                :style="{ borderColor: primaryColor }"
                v-if="engrainMapLink"
              >
                <v-icon medium :color="primaryColor">mdi-map-marker</v-icon>
                <p :style="{ color: primaryColor }">Show Map</p>
              </a>
            </div>
          </div>

          <v-card-title
            v-if="!useFPName"
            class="rentpress-inherited-font-family text-h3 secondary--text pl-0"
          >
            {{ displayBedroomsText }}
          </v-card-title>
          <v-card-subtitle
            v-if="useFPName"
            class="rentpress-inherited-font-family text-h5 pb-1 pt-2 pl-0 rentpress-single-floorplan-main-info-block"
          >
            <span
              v-if="displayBedroomsText"
              class="rentpress-floorplan-bedroom-text"
            >
              {{ displayBedroomsText }}
            </span>
            <span v-if="sqFtText" class="rentpress-floorplan-sqft">
              <span class="rentpress-floorplan-information-dot-sep"> • </span
              >{{ sqFtText }}
            </span>
            <span
              v-if="displayDepositText"
              class="rentpress-floorplan-deposit-range"
            >
              <span class="rentpress-floorplan-information-dot-sep"> • </span
              >{{ displayDepositText }} Deposit
            </span>
          </v-card-subtitle>
          <div v-if="floorplan.units.length > 0">
            <v-card-text
              class="
                rentpress-inherited-font-family
                rentpress-floorplan-single-information-subtitle
                text-h6
                font-weight-bold
                pl-0
              "
            >
              Choose An Apartment
            </v-card-text>
            <div
              class="rentpress-units-selection-wrapper rentpress-units-wrapper"
            >
              <div v-if="floorplan.units.length > 2">
                <v-icon
                  x-large
                  :color="primaryColor"
                  @click="scrollUnitSlider('left')"
                  >mdi-chevron-left</v-icon
                >
              </div>
              <div class="rentpress-units-selection-container" ref="unitSlider">
                <div
                  v-for="unit in sortedUnits"
                  v-bind:key="unit.unit_code"
                  style="
                    display: inline-block;
                    padding-right: 8px;
                    padding-left: 0px;
                    padding-top: 8px;
                    padding-bottom: 16px;
                    width: 260px;
                  "
                >
                  <div v-on:click="selectThisUnit(unit)">
                    <unit-card
                      v-if="unit"
                      :unit="unit"
                      :options="options"
                      :formatter="formatter"
                      :primaryColor="primaryColor"
                      :disabledPrice="
                        floorplan.floorplan_rent_type_selection == 'Disabled'
                      "
                      :isActive="isActiveUnit(unit.unit_code)"
                    />
                  </div>
                </div>
              </div>
              <div v-if="floorplan.units.length > 2">
                <v-icon
                  x-large
                  :color="primaryColor"
                  @click="scrollUnitSlider('right')"
                  >mdi-chevron-right</v-icon
                >
              </div>
            </div>
          </div>
          <div
            v-else
            class="rentpress-inherited-font-family rentpress-units-wrapper rentpress-no-units-text"
          >
            <h4 class="rentpress-no-units-headline">No Apartments Available</h4>
            <p class="rentpress-no-units-message">
              This is one of our most popular layouts. No apartments are
              currently available.
            </p>
          </div>
          <div
            v-if="selectedUnit.unit_specials_message"
            class="rentpress-units-special-container"
          >
            <div
              class="rentpress-inherited-font-family text-h6 font-weight-bold"
            >
              Current Special for
              {{ selectedUnit.unit_name }}:
            </div>
            <div class="rentpress-unit-special-text">
              <p>{{ JSON.parse(selectedUnit.unit_specials_message)[0] }}</p>
            </div>
          </div>
          <div
            v-if="selectedUnitFeatures.length"
            class="rentpress-units-feature-container"
          >
            <v-card-text
              class="rentpress-inherited-font-family text-h6 font-weight-bold"
              >Features for {{ selectedUnit.unit_name }}:
            </v-card-text>
            <div id="rentpress-unit-features-list">
              <div
                v-for="feature in selectedUnitFeatures"
                :key="feature.Rank"
                class="rentpress-unit-features-list-item"
              >
                <v-icon :color="primaryColor">mdi-chevron-right</v-icon>
                {{ feature.Title }}
              </div>
            </div>
          </div>

          <div
            v-if="selectedUnitTerms.length && propertyHasLeaseTermsSelected"
            class="rentpress-units-term-container"
          >
            <v-card-text
              class="rentpress-inherited-font-family text-h6 font-weight-bold"
              >Available Lease Terms for {{ selectedUnit.unit_name }}
            </v-card-text>
            <v-row>
              <v-col xl="5" lg="6" md="5" sm="7" cols="12">
                <v-menu
                  v-model="termRentDisplay"
                  :close-on-content-click="true"
                  bottom
                  origin="center center"
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="rentpress-inherited-font-family">
                      <v-select
                        solo
                        :label="
                          selectedLeaseTerm
                            ? selectedLeaseTerm +
                              ' Months: ' +
                              formatter.format(selectedLeaseRent)
                            : 'Show Terms'
                        "
                        readonly
                      ></v-select>
                    </div>
                  </template>
                  <v-list
                    id="rentpress-units-term-menu-list"
                    class="rentpress-inherited-font-family"
                    style="overflow-y: auto; max-height: 60vh"
                  >
                    <v-list-item>
                      <v-row justify="end" class="font-weight-bold">
                        <v-col cols="5"> Lease Term </v-col>
                        <v-col cols="7"> Price Per Month </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item
                      v-for="(term, termIndex) in selectedUnitTerms"
                      v-bind:key="termIndex"
                      :value="term.Rent"
                      :class="
                        isBestLeaseValue(term)
                          ? 'font-weight-bold term-list-item term-list-item-best'
                          : 'term-list-item'
                      "
                    >
                      <v-row
                        @click="setDesiredLeaseTerm(term)"
                        style="cursor: pointer"
                      >
                        <v-col cols="5"> {{ term.Term }} Months </v-col>
                        <v-col cols="7">
                          {{ formatter.format(term.Rent) }}
                          <span
                            v-if="isBestLeaseValue(term)"
                            style="white-space: nowrap"
                          >
                            (Best Value)</span
                          >
                        </v-col>
                      </v-row>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </div>
          <v-row
            justify="start"
            class="pt-3 rentpress-single-floorplan-main-info-block-cta-wrapper"
          >
            <v-col
              v-if="options.rentpress_application_link_section_url_tour != ''"
              cols="12"
              xl="4"
              lg="4"
              md="4"
              sm="4"
            >
              <v-btn
                :color="primaryColor"
                x-large
                block
                @click="
                  navigateTo(tourLink);
                  gtag('event', 'scheduletour_click_rentpress', {
                    property_name: floorplan.property_name,
                    city: floorplan.property_city,
                    floorplan_name: floorplan.floorplan_post_title
                  });
                "
                class="rentpress-application-link-section-url-tour-button rentpress-cta-tour white--text "
              >
                Schedule Tour
              </v-btn>
            </v-col>
            <v-col cols="12" xl="4" lg="4" md="4" sm="4">
              <div
                v-if="floorplan.floorplan_parent_property_contact_type == '3'"
              >
                <v-btn
                  block
                  :color="primaryColor"
                  class="rentpress-inherited-font-family rentpress-cta-info"
                  x-large
                  outlined
                  @click="
                    gtag('event', 'requestinfo_click_rentpress', {
                      property_name: floorplan.property_name,
                      city: floorplan.property_city,
                      floorplan_name: floorplan.floorplan_post_title
                    });
                    openGravityFormsModal(floorplan.floorplan_post_id);
                  "
                >
                  Request Info
                </v-btn>
                <v-dialog
                  v-model="propertyGravityForm"
                  fullscreen
                  hide-overlay
                  transition="dialog-bottom-transition"
                  scrollable
                >
                  <v-card tile>
                    <v-btn
                      color="#303030"
                      fab
                      dark
                      small
                      absolute
                      top
                      right
                      @click="propertyGravityForm = ''"
                      class="mt-6 mr-n3"
                      elevation="10"
                      style=""
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <div
                      class="floorplan-form-pop-up"
                      v-html="floorplanForm"
                      ref="gravityform"
                    ></div>
                  </v-card>
                </v-dialog>
              </div>
              <div v-else>
                <v-btn
                  block
                  :color="primaryColor"
                  class="rentpress-inherited-font-family rentpress-cta-info"
                  x-large
                  :outlined="
                    options.rentpress_application_link_section_url_tour != ''
                  "
                  @click="
                    gtag('event', 'requestinfo_click_rentpress', {
                      property_name: floorplan.property_name,
                      city: floorplan.property_city,
                      floorplan_name: floorplan.floorplan_post_title
                    });
                    navigateTo(contactLink);
                  "
                >
                  Request Info
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" xl="4" lg="4" md="4" sm="4">
              <v-btn
                v-if="hasUnits && applyLink"
                :color="primaryColor"
                class="rentpress-inherited-font-family rentpress-cta-apply"
                block
                x-large
                outlined
                @click="
                  navigateToExternalSite(applyLink);
                  gtag('event', 'applynow_click_rentpress', {
                    property_name: floorplan.property_name,
                    city: floorplan.property_city,
                    floorplan_name: floorplan.floorplan_post_title
                  });
                "
              >
                Apply Now
              </v-btn>
              <v-btn
                v-if="
                  !hasUnits &&
                    options.rentpress_application_link_section_url_waitlist !=
                      ''
                "
                :color="primaryColor"
                class="rentpress-inherited-font-family rentpress-cta-waitlist"
                x-large
                block
                outlined
                @click="
                  navigateTo(waitlistLink);
                  gtag('event', 'joinwaitlist_click_rentpress', {
                    property_name: floorplan.property_name,
                    city: floorplan.property_city,
                    floorplan_name: floorplan.floorplan_post_title
                  });
                "
              >
                Join Waitlist
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            class="rentpress-single-floorplan-main-info-block-social-wrapper"
          >
            <v-col cols="auto">
              <p
                class="
                  rentpress-inherited-font-family
                  font-weight-bold
                  secondary--text
                  pt-1
                  rentpress-share-icons
                "
              >
                SHARE
              </p>
            </v-col>
            <v-col cols="auto">
              <v-tooltip bottom open-delay="300">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    :href="emailLink"
                    target="_blank"
                    class="rentpress-share-icon-email"
                  >
                    <v-icon class="white--text secondary">mdi-email</v-icon>
                  </v-btn>
                </template>
                Share via email
              </v-tooltip>
              <v-tooltip bottom open-delay="300">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    :href="smsLink"
                    class="rentpress-share-icon-sms hidden-md-and-up"
                  >
                    <v-icon class="white--text secondary"
                      >mdi-comment-text-outline</v-icon
                    >
                  </v-btn>
                </template>
                Share via SMS
              </v-tooltip>
              <v-tooltip bottom open-delay="300">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    @click="copyToClipboard"
                    class="rentpress-share-icon-copy"
                  >
                    <v-icon class="white--text secondary"
                      >mdi-link-variant-plus</v-icon
                    >
                  </v-btn>
                </template>
                Copy link
              </v-tooltip>
              <v-tooltip bottom open-delay="300">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    :href="facebookLink"
                    target="_blank"
                    class="rentpress-share-icon-facebook"
                  >
                    <v-icon class="white--text secondary">mdi-facebook</v-icon>
                  </v-btn>
                </template>
                Share via Facebook
              </v-tooltip>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <script v-html="jsonld" type="application/ld+json"></script>
  </div>
</template>

<script>
import unitCard from "./unit-card.vue";

export default {
  name: "single-floorplan-information",
  data: function() {
    return {
      hasUnits: false,
      useFPName: true,
      hasSelectedUnit: false,
      propertyHasLeaseTermsSelected: false,
      selectedUnit: {},
      selectedUnitTerms: [],
      selectedUnitFeatures: [],
      selectedLeaseTerm: "",
      selectedLeaseRent: "",
      bestLeaseValue: "",
      image: this.options.rentpress_default_floor_plan_image_section,
      carouselImages: [],
      sqFtText: "",
      facebookLink: "",
      emailLink: "",
      smsLink: "",
      propertyGravityForm: "",
      formInputs: "",
      termRentDisplay: false,
      displayBedroomsText: this.getTextForBedroomsDisplay(),
      primaryColor: this.options.rentpress_accent_color_section_input,
      selectedGalleryImage: 0,
      galleryOverlay: false,
      secondary: this.options.rentpress_secondary_accent_color_section_input,
      unitSliderScrollAmount: 0,
      jsonld: {
        // single floor plan schema
        "@type": "ItemPage",
        primaryImageOfPage: this.floorplan.floorplan_image,
        significantLink: this.floorplan.applyLink,
        about: {
          "@type": "Product",
          name: this.floorplan.floorplan_post_title,
          image: this.floorplan.floorplan_image,
          description: this.floorplan.floorplan_description,
          brand: this.options.site_name,
          offers: {
            "@type": "aggregateOffer",
            lowPrice: this.floorplan.floorplan_rent_min,
            highPrice: this.floorplan.floorplan_rent_max,
            priceCurrency: "USD",
            offerCount: this.floorplan.floorplan_units_available
          },
          sku: this.floorplan.floorplan_code
        },
        breadcrumb: [
          {
            itemListElement: [
              {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                itemListElement: [
                  {
                    "@type": "ListItem",
                    position: 1,
                    name: this.options.site_name + " Home",
                    item: this.options.site_url
                  },
                  {
                    "@type": "ListItem",
                    position: 3,
                    // name: this.property.property_name,
                    item: this.floorplan.floorplan_parent_property_post_link
                  }
                ]
              }
            ]
          }
        ],
        mainEntity: [
          {
            "@type": "FloorPlan",
            image: this.floorplan.floorplan_image,
            description: this.floorplan.floorplan_description,
            name: this.floorplan.floorplan_post_title,
            url: this.floorplan.floorplan_post_link,
            floorsize: this.floorplan.floorplan_sqft_min,
            // isPlanForApartment: this.floorplan.floorplan_parent_property_name,
            numberOfBedrooms: this.floorplan.floorplan_bedrooms,
            numberOfBathroomsTotal: this.floorplan.floorplan_bathrooms,
            petsAllowed: this.displayPetText
          },
          {
            containedInPlace: {
              "@type": "LocalBusiness",
              // name: this.floorplan.floorplan_parent_property_name,
              // description: this.floorplan.property_description,
              priceRange: "",
              // telephone: this.floorplan.property_phone_number,
              image: this.floorplan.floorplan_image,
              address: {
                "@type": "PostalAddress"
                // streetAddress: this.floorplan.property_address,
                // addressLocality: this.floorplan.property_city,
                // addressRegion: this.floorplan.property_state,
                // postalCode: this.floorplan.property_zip
              },
              geo: {
                "@type": "GeoCoordinates"
                // latitude: this.floorplan.property_latitude,
                // longitude: this.floorplan.property_longitude
              },
              "@id": this.floorplan.floorplan_parent_property_post_link
            }
          }
        ],
        "@context": "https://schema.org"
      }
    };
  },
  props: {
    floorplan: Object,
    options: Object,
    formatter: Intl.NumberFormat,
    shortcode: {
      type: String,
      default: ""
    }
  },
  computed: {
    parentPropertyColor() {
      let color = this.options.rentpress_accent_color_section_input;
      if (this.floorplan.floorplan_parent_property_use_accent_color === "1") {
        color = this.floorplan.floorplan_parent_property_accent_color;
      }
      return color;
    },
    engrainMapLink() {
      const link = this.floorplan.floorplan_parent_property_engrain_url;
      if (link) {
        return typeof link !== "undefined" ? link : "";
      }
      return "";
    },
    floorplanForm() {
      let contact_type = this.floorplan.floorplan_parent_property_contact_type;
      const formEl = document.getElementById(
        this.floorplan.floorplan_parent_property_code + "_form_wrapper"
      );
      if (formEl && contact_type && contact_type != "Global Setting") {
        return formEl.innerHTML;
      }
      return "";
    },
    displayDepositText() {
      let depositMin = Number(this.floorplan.floorplan_deposit_min);
      let depositMax = Number(this.floorplan.floorplan_deposit_max);
      let globalDepositSetting = this.options
        .rentpress_deposit_settings_section_deposit_settings;
      const propDepositSetting = Number(
        this.floorplan.floorplan_parent_property_deposit_setting
      );

      switch (propDepositSetting) {
        case 1:
          // Global Setting
          switch (globalDepositSetting) {
            case "Always Show":
              // dont do anything
              break;
            case "Exclude $0 Deposits":
              if (depositMin === 0) {
                depositMin = null;
              }
              if (depositMax === 0) {
                depositMax = null;
              }
              break;
            case "Show None":
              depositMin = null;
              depositMax = null;
              break;

            default:
          }
          break;
        case 2:
          // Always Show
          break;
        case 3:
          // Exclude $0 Deposits
          if (depositMin === 0) {
            depositMin = null;
          }
          if (depositMax === 0) {
            depositMax = null;
          }
          break;

        case 4:
          // Show None
          depositMin = null;
          depositMax = null;
          break;

        default:
          switch (globalDepositSetting) {
            case "Always Show":
              // dont do anything
              break;
            case "Exclude $0 Deposits":
              if (depositMin === 0) {
                depositMin = null;
              }
              if (depositMax === 0) {
                depositMax = null;
              }
              break;
            case "Show None":
              depositMin = null;
              depositMax = null;
              break;

            default:
          }
          break;
      }

      var depositText = "";
      if (depositMin !== null || depositMax !== null) {
        depositText += "$";
        if (depositMin === depositMax) {
          depositText += depositMax;
          return depositText;
        }
        if (depositMin !== null && depositMax !== null) {
          depositText += depositMin + " - $" + depositMax;
          return depositText;
        }
        if (depositMin !== null) {
          depositText += depositMin;
          return depositText;
        }
        if (depositMax !== null) {
          depositText += depositMax;
          return depositText;
        }
      }
      return depositText;
    },
    sortedUnits() {
      var units = this.floorplan.units;
      units.sort(function(a, b) {
        let aStamp = new Date(a.unit_available_on).getTime();
        let bStamp = new Date(b.unit_available_on).getTime();
        return aStamp > bStamp ? 1 : -1;
      });
      return units;
    },
    unitParamString() {
      let paramString = "";
      if (this.hasSelectedUnit && this.selectedUnit.unit_code) {
        paramString = "&unit_code=" + this.selectedUnit.unit_code;
        paramString = this.selectedLeaseTerm
          ? paramString + "&leaseTerm=" + this.selectedLeaseTerm
          : paramString;
      }
      return paramString;
    },
    applyLink() {
      if (this.hasSelectedUnit && this.selectedUnit.unit_availability_url) {
        return this.selectedUnit.unit_availability_url;
      } else if (this.floorplan.floorplan_availability_url) {
        return this.floorplan.floorplan_availability_url;
      } else {
        return this.options
          .rentpress_application_link_section_default_application_url;
      }
    },
    contactLink() {
      const baseURL =
        this.floorplan.floorplan_parent_property_contact_link != "" &&
        this.floorplan.floorplan_parent_property_contact_link != null
          ? this.floorplan.floorplan_parent_property_contact_link
          : this.options.rentpress_application_link_section_url_contact;
      return (
        baseURL +
        "?property_code=" +
        this.floorplan.floorplan_parent_property_code +
        "&property_name=" +
        this.floorplan.property_name +
        "&floorplan_code=" +
        this.floorplan.floorplan_code +
        "&floorplan_bed=" +
        this.floorplan.floorplan_bedrooms +
        this.unitParamString
      );
    },
    tourLink() {
      return (
        this.options.rentpress_application_link_section_url_tour +
        "?property_code=" +
        this.floorplan.floorplan_parent_property_code +
        "&property_name=" +
        this.floorplan.property_name +
        "&floorplan_code=" +
        this.floorplan.floorplan_code +
        this.unitParamString
      );
    },
    waitlistLink() {
      return (
        this.options.rentpress_application_link_section_url_waitlist +
        "?property_code=" +
        this.floorplan.floorplan_parent_property_code +
        "&property_name=" +
        this.floorplan.property_name +
        "&floorplan_code=" +
        this.floorplan.floorplan_code +
        this.unitParamString
      );
    }
  },
  methods: {
    openGravityFormsModal(id) {
      this.propertyGravityForm = id;
      this.$nextTick(() => {
        let form = this.$refs["gravityform"];
        if (form && form != undefined && form != null) {
          let formFields = form.querySelectorAll("input");
          for (var i = formFields.length - 1; i >= 0; i--) {
            let field = formFields[i];
            switch (field.value) {
              case "floorplan_code":
                field.value = this.floorplan.floorplan_code;
                break;
            }
          }
        }
      });
    },
    scrollUnitSlider(direction) {
      if (direction === "right") {
        this.unitSliderScrollAmount = this.unitSliderScrollAmount + 260;
      }
      if (direction === "left") {
        this.unitSliderScrollAmount = this.unitSliderScrollAmount - 260;
      }
      this.$refs["unitSlider"].scrollTo({
        top: 0,
        left: this.unitSliderScrollAmount,
        behavior: "smooth"
      });
    },
    getTextForBedroomsDisplay() {
      let displayText =
        this.floorplan.floorplan_bedrooms == "0"
          ? "Studio"
          : this.floorplan.floorplan_bedrooms + " Bed";
      return displayText + " | " + this.floorplan.floorplan_bathrooms + " Bath";
    },
    navigateToExternalSite(newLocation) {
      // exit out of function if no link, this only happens with banner link, if in the future we switch from the whole banner being a link to a button, this can be removed
      if (!newLocation) {
        return;
      }
      if (newLocation.includes("http")) {
        window.open(newLocation, "_blank");
      } else {
        window.open("http://" + newLocation, "_blank");
      }
    },
    navigateTo(newLocation) {
      window.location = newLocation.includes("http")
        ? newLocation
        : "http://" + newLocation;
    },
    selectThisUnit: function(selection) {
      if (this.selectedUnit.unit_code === selection.unit_code) {
        this.selectedUnit = {};
        this.hasSelectedUnit = false;
        this.selectedUnitFeatures = [];
        this.selectedUnitTerms = [];
      } else {
        this.selectedUnit = selection;
        this.unitSelected(selection);
        this.hasSelectedUnit = true;
        this.selectedUnitFeatures =
          JSON.parse(selection.unit_features) !== null
            ? JSON.parse(selection.unit_features)
            : [];
        this.selectedUnitTerms =
          JSON.parse(selection.unit_rent_terms) !== null
            ? JSON.parse(selection.unit_rent_terms)
            : [];
        this.propertyHasLeaseTermsSelected =
          selection.unit_rent_type_selection == "Term Rent";
        this.selectedLeaseTerm = "";
        this.bestLeaseValue = "";
        if (
          this.selectedUnitTerms.length &&
          this.propertyHasLeaseTermsSelected
        ) {
          for (
            let index = this.selectedUnitTerms.length - 1;
            index >= 0;
            index--
          ) {
            if (
              this.formatter.format(this.selectedUnitTerms[index].Rent) ==
              this.formatter.format(
                this.selectedUnit.unit_rent_type_selection_cost
              )
            ) {
              this.bestLeaseValue = this.selectedUnitTerms[index].Term;
              break;
            }
          }
        }
      }
      this.setUpCarousel();
    },
    setDesiredLeaseTerm(term) {
      this.selectedLeaseTerm = term.Term;
      this.selectedLeaseRent = term.Rent;
    },
    isActiveUnit(unit_code) {
      return unit_code == this.selectedUnit.unit_code;
    },
    isBestLeaseValue(term) {
      return term.Term == this.bestLeaseValue;
    },
    setUpCarousel() {
      this.carouselImages = [];
      if (this.selectedUnit.unit_images) {
        let imagesArray = JSON.parse(this.selectedUnit.unit_images);
        if (imagesArray !== null) {
          imagesArray.forEach(image => {
            let thisImage = {};
            if (typeof image === "string") {
              thisImage = {
                src: image,
                alt:
                  "Image of unit " +
                  this.selectedUnit.unit_name +
                  " at " +
                  this.floorplan.floorplan_post_title +
                  " floor plan"
              };
              this.carouselImages.push(thisImage);
            } else if (
              typeof image === "object" &&
              !Array.isArray(image) &&
              image !== null
                ? image.url
                : ""
            ) {
              thisImage = {
                src: image.url,
                alt:
                  "Image for " +
                  this.floorplan.floorplan_post_title +
                  " floor plan"
              };
              if (image.alt_text ?? "") {
                thisImage.alt = image.alt_text;
              }
              this.carouselImages.push(thisImage);
            }
          });
        }
      }

      if (this.floorplan.floorplan_featured_image) {
        this.carouselImages.push({
          src: this.floorplan.floorplan_featured_image,
          alt: "Image of " + this.floorplan.floorplan_post_title + " floor plan"
        });
      }
      if (this.floorplan.floorplan_image) {
        this.carouselImages.push({
          src: this.floorplan.floorplan_image,
          alt: "Image of " + this.floorplan.floorplan_post_title + " floor plan"
        });
      }

      if (this.floorplan.floorplan_images) {
        const imagesArray = JSON.parse(this.floorplan.floorplan_images);
        if (imagesArray !== null) {
          imagesArray.forEach(image => {
            const thisImage = {
              src: image.url,
              alt: image.alt
            };
            this.carouselImages.push(thisImage);
          });
        }
      }

      if (!this.carouselImages.length) {
        if (this.floorplan.floorplan_unit_images != null) {
          let unit_images = JSON.parse(this.floorplan.floorplan_unit_images);
          if (unit_images.length ? unit_images[0] : "") {
            this.carouselImages.push({
              src: unit_images[0],
              alt: "unit image of " + this.floorplan.floorplan_post_title
            });
          }
        } else {
          this.carouselImages.push({
            src: this.options.rentpress_default_floor_plan_image_section,
            alt: "Placeholder image of " + this.floorplan.floorplan_post_title
          });
        }
      }
    },
    gallerySwipe(direction) {
      this.swipeDirection = direction;
      if (direction === "Right") {
        this.selectedGalleryImage = this.selectedGalleryImage++;
      }
      if (direction === "Left") {
        this.selectedGalleryImage = this.selectedGalleryImage--;
      }
      if (direction === "Down") {
        this.galleryOverlay = false;
      }
    },
    viewImageFullscreen(key) {
      this.selectedGalleryImage = key;
      this.galleryOverlay = true;
    },
    unitSelected(unit) {
      this.$emit("selectedunit", unit);
    },
    copyToClipboard() {
      let copyText = window.location.href;
      navigator.clipboard.writeText(copyText).then(() => {
        alert("Link to page copied to clipboard: \n" + window.location.href);
      });
    }
  },
  mounted: function() {
    if (
      this.floorplan.floorplan_parent_property_use_accent_color === "1" &&
      this.floorplan.floorplan_parent_property_accent_color &&
      this.floorplan.floorplan_parent_property_accent_color != null
    ) {
      this.primaryColor = this.floorplan.floorplan_parent_property_accent_color;
    }
    this.setUpCarousel();
    if (
      this.floorplan.floorplan_sqft_max &&
      this.floorplan.floorplan_sqft_min
    ) {
      this.sqFtText =
        this.floorplan.floorplan_sqft_max != this.floorplan.floorplan_sqft_min
          ? `${this.floorplan.floorplan_sqft_min} - ${this.floorplan.floorplan_sqft_max} Sq. Ft`
          : `${this.floorplan.floorplan_sqft_max} Sq. Ft.`;
    } else if (this.floorplan.floorplan_sqft_max) {
      this.sqFtText = `${this.floorplan.floorplan_sqft_max} Sq. Ft.`;
    } else if (this.floorplan.floorplan_sqft_min) {
      this.sqFtText = `${this.floorplan.floorplan_sqft_min} Sq. Ft.`;
    }

    this.hasUnits =
      this.floorplan.units && this.floorplan.units.length > 0 ? true : false;

    this.propertyHasLeaseTermsSelected =
      this.floorplan.floorplan_rent_type_selection == "Term Rent";

    this.smsLink = "sms://?&body=" + window.location.href;

    this.facebookLink =
      "https://www.facebook.com/sharer.php?u=" + window.location.href;

    this.emailLink =
      "mailto:?subject=Check Out This Apartment&body=I liked this apartment " +
      this.floorplan.floorplan_post_title +
      ". What do you think? " +
      window.location.href;
  },
  components: { unitCard }
};
</script>

<style>
.v-carousel__controls {
  background: none;
}
.v-carousel__controls > .v-item-group {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 15px;
  padding: 5px;
  transform: scale(0.86);
}
.v-carousel__controls > .v-item-group:hover {
  background-color: rgba(0, 0, 0, 0.75);
  border-radius: 5px;
  padding: 5px;
  transform: scale(1);
}
.rentpress-units-selection-container {
  display: flex;
  overflow-x: auto !important;
  flex-wrap: nowrap;
  align-items: center;
  flex-direction: row;
  width: 90%;
}

.rentpress-floorplan-carousel {
  aspect-ratio: 1.25/1;
}

.rentpress-floorplan-carousel-image {
  cursor: zoom-in;
  aspect-ratio: 1.3/1;
}

.rentpress-floorplan-carousel-image-lightbox {
  background-color: white;
  -webkit-box-shadow: 0px 0px 30px 0px rgba(77, 77, 77, 0.3);
  -moz-box-shadow: 0px 0px 30px 0px rgba(77, 77, 77, 0.3);
  box-shadow: 0px 0px 30px 0px rgba(77, 77, 77, 0.3);
}

#rentpress-units-term-menu-list .term-list-item:hover {
  background-color: var(--primary-color) !important;
  color: white !important;
  font-weight: 900;
}

#rentpress-units-term-menu-list .term-list-item-best {
  color: var(--primary-color) !important;
}

.floorplan-form-pop-up {
  padding: 2%;
}

.floorplan-form-pop-up-close-btn {
  padding-top: 5%;
}
.rentpress-magnify-carousel-image-wrapper {
  display: block;
  position: relative;
  bottom: -30px;
}

.rentpress-units-special-container {
  padding: 1rem;
}

#rentpress-unit-features-list {
  columns: 2;
}
.rentpress-floorplan-information-title-price-wrapper {
  min-width: 70%;
  display: inline-block;
}
.rentpress-floorplan-iframe-buttons {
  display: inline-flex;
  align-items: center;
  width: 30%;
  min-width: 220px;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
}
.circle-button {
  border: 3px solid var(--primary-color);
  height: 100px;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  width: 100px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  text-align: center;
  align-content: center;
  justify-content: center;
  margin-right: 5px;
  text-decoration: none;
}
.circle-button .v-icon {
  flex: 0 0 100%;
}
.circle-button p {
  width: 80%;
  font-size: 1.2em;
  line-height: 1.3;
  margin: 0;
}
.rentpress-floorplan-information-top-wrapper {
  display: flex;
}
.rentpress-units-selection-wrapper {
  display: flex;
  align-items: center;
  flex-direction: row;
}
.rentpress-floorplan-under-image-buttons {
  display: none;
}

@media only screen and (max-width: 800px) {
  .rentpress-floorplan-information-title-price-wrapper {
    min-width: 60%;
  }
}

@media only screen and (max-width: 580px) {
  .rentpress-floorplan-title-buttons {
    display: none;
  }
  .rentpress-floorplan-under-image-buttons {
    display: inline-flex;
    justify-content: center;
    width: 100%;
    margin-top: 20px;
  }
  .rentpress-single-floorplan-main-info-block {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .rentpress-single-floorplan-main-info-block span {
    width: 100%;
  }
  .rentpress-floorplan-information-dot-sep {
    display: none;
  }
  .rentpress-share-icon-copy {
    background: unset !important;
  }
}
</style>
